import { defineStore } from 'pinia'

export const useGlobalsStore = defineStore('globals', {
    state: () => ({
        menuState: false,
        notificationState: false,
        amountOfArticles: 9,
        globalPlayerState: false // enables/disables podcast player globally
    }),

    actions: {
        changeMenuState (state: boolean) {
            this.menuState = state
        },

        changeNotificationState (state: boolean) {
            this.notificationState = state
        },

        changeArticleAmount (value: number) {
            this.amountOfArticles = value
        },
    }
})